import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Text } from 'roo-ui/components';
import { getMapLinkQueryString } from 'store/search/searchSelectors';
import IconButton from 'components/IconButton';
import AppLink from 'components/AppLink';
import { useDataLayer } from 'hooks/useDataLayer';

const ListSearchButton = React.memo(() => {
  const queryString = useSelector(getMapLinkQueryString);
  const searchListLink = { pathname: '/search/list', search: queryString };
  const { emitInteractionEvent } = useDataLayer();

  const onClick = useCallback(() => {
    emitInteractionEvent({ type: 'Mobile Fixed Controls', value: 'List Search Button Selected' });
  }, [emitInteractionEvent]);

  return (
    <IconButton icon="list" to={searchListLink} as={AppLink} variant="mobilePillButton" onClick={onClick}>
      <Text fontSize="md">List View</Text>
    </IconButton>
  );
});

ListSearchButton.displayName = 'ListSearchButton';

export default ListSearchButton;
